import React from 'react'
import PrimaryButton from '../buttons/PrimaryButton'
import InputPrimary from '../forms/InputPrimary'
import SelectPrimary from '../forms/SelectPrimary'
import { motion } from 'framer-motion'
import CountrySelect from '../common/CountrySelect'
import AgeSelect from '../common/AgeSelect'
import { AGE_RANGE_OPTIONS } from '../../constants/age_range'

const Step1 = ({ handleNextStep, register, watch, errors, control }) => {
  const allFields = watch([
    'fullName',
    'dateOfBirth',
    'country',
    'age',
    'organizationName',
  ])
  const isFormFilled = allFields.every((field) => field && field.trim() !== '')

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
      className="step1-container"
    >
      <p className="text-3xl text-primary font-bold text-center mb-6">
        Set up your profile
      </p>

      <div className="space-y-4">
        <div>
          <label htmlFor="fullName" className="font-bold mb-4">
            Choose your player name
          </label>
          <InputPrimary
            type="text"
            id="fullName"
            {...register('fullName', { required: 'Player name is required' })}
            placeholder="Please enter your player name"
          />
          {errors.fullName && (
            <p className="text-red-500 text-sm">{errors.fullName.message}</p>
          )}
        </div>

        <div>
          <label htmlFor="dateOfBirth" className="font-bold mb-4">
            Date of Birth
          </label>
          <InputPrimary
            type="date"
            id="dateOfBirth"
            {...register('dateOfBirth', {
              required: 'Date of birth is required',
            })}
          />
          {errors.dateOfBirth && (
            <p className="text-red-500 text-sm">{errors.dateOfBirth.message}</p>
          )}
        </div>

        <div>
          <label htmlFor="country" className="font-bold mb-4">
            Country
          </label>
          <CountrySelect
            id="country"
            control={control}
            validation={{ required: 'Country is required' }}
          />
          {errors.country && (
            <p className="text-red-500 text-sm">{errors.country.message}</p>
          )}
        </div>

        <div>
          <label htmlFor="age_range" className="font-bold mb-4">
            Select your age range
          </label>
          <SelectPrimary
            id="age_range"
            options={AGE_RANGE_OPTIONS}
            register={register}
            defaultOption="Please select your age range"
          />
          {errors.age_range && (
            <p className="text-red-500 text-sm">{errors.age_range.message}</p>
          )}
        </div>

        <div>
          <label htmlFor="fullName" className="font-bold mb-4">
            Name of organization / School
          </label>
          <InputPrimary
            type="text"
            id="organizationName"
            {...register('organizationName', {
              required: 'Name of organization / School is required',
            })}
            placeholder="Please enter Name of organization / School"
          />
          {errors.organizationName && (
            <p className="text-red-500 text-sm">
              {errors.organizationName.message}
            </p>
          )}
        </div>

        <PrimaryButton
          disabled={!isFormFilled}
          onClick={handleNextStep}
          className="w-full"
          type="button"
        >
          Continue
        </PrimaryButton>
      </div>
    </motion.div>
  )
}

export default Step1
